/** Joins class names, skipping empty values. */
export function cx(...names) {
    return names.filter(Boolean).join(' ');
}
/** Class names of a Trace button, for links or router links that must look like one. */
export function traceButtonClass(variant = 'primary', options = {}) {
    return cx('trace-auth-button', `trace-auth-button--${variant}`, options.block && 'trace-auth-button--block');
}
//# sourceMappingURL=cx.js.map